export const introPosition = { right: "4%", top: "20%", transform: "translate(-4%, -20%)" };
export const defaultPosition = { left: "60%", top: "22%", transform: "translate(-60%, -22%)" };
export const mintPosition = { left: "62.5%", top: "19%", transform: "translate(-62.5%, -19%)" };